"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Star } from "lucide-react";
export default function RecevoirMonDevisPersonnalise() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: containerRef,
    isVisible: containerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const testimonials = [{
    name: "Sophie Martin",
    text: "Be Travaux a transformé ma cuisine en un espace moderne et fonctionnel. L'artisan était professionnel et ponctuel. Je recommande vivement !",
    rating: 5
  }, {
    name: "Pierre Dubois",
    text: "Excellent service pour mes travaux d'isolation. Les conseils sur les aides financières m'ont fait économiser beaucoup d'argent. Merci !",
    rating: 5
  }, {
    name: "Marie Lefèvre",
    text: "Rénovation complète de ma salle de bain réalisée en temps et en heure. La plateforme est simple à utiliser et les artisans sont qualifiés.",
    rating: 5
  }];
  return <section className="py-16 px-4 bg-background">
      <div className="max-w-7xl mx-auto">
        <div ref={headingRef} className={`text-center mb-12 transition-all duration-700 ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground">
            Recevoir mon devis personnalisé
          </h2>
        </div>

        <div ref={containerRef} className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, i) => <div key={i} data-index={i} className={`card p-8 transition-all duration-700 ${containerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: containerVisible ? `${200 + i * 100}ms` : "0ms"
        }}>
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, starIndex) => <Star key={starIndex} className="w-5 h-5 fill-secondary text-secondary" />)}
              </div>

              <p className="text-foreground text-base leading-relaxed mb-6">
                "{testimonial.text}"
              </p>

              <p className="font-display font-semibold text-primary text-lg">
                {testimonial.name}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}